import React, { Component } from "react";
import { toastContainer } from "../../utils/toast";
import { isMobile } from "../../utils/deviceInfo";
import "./trivia-survey.css";
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import { GiBigGear, GiOpenTreasureChest } from "react-icons/gi";
import { LuCalendarCheck } from "react-icons/lu";
import { CSVLink } from "react-csv";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdFileUpload } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutHeadingLines,
  LayoutDataLines,
  LayoutRowLines,
  LayoutRow,
} from "../../components/TableComponents/RowCardShadow/RowCardShadow";

import {
  formatDuration,
  getTrivvyRating,
  isTrivvyGeneratedFromCustomTemplates,
  SURVEY_LIST,
  WEB_GENERATE_ERROR_MESSAGE,
} from "./data";
import ReactTooltip from "react-tooltip";
import If from "../../components/Shared/If";
import { SURVEY_QUESTIONS } from "../../components/Survey/data";
import {
  BiDotsHorizontal,
  BiDownArrowAlt,
  BiEditAlt,
  BiNotepad,
  BiUpArrowAlt,
  BiX,
} from "react-icons/bi";
import { BsDownload, BsGearFill, BsThreeDots } from "react-icons/bs";
import RenamePopup from "./Components/RenamePopup";
import DeleteTriviaPopup from "./Components/DeleteTriviaPopup";
import { orderBy } from "lodash";
import CreateSurveyPopup from "./Components/CreateTrivia/CreateTriviaPopup";
import RewardCreateModal from "./Components/RewardCreateModal";

import EmptyTable from "../../components/EmptyTable/EmptyTable";
import { baseUrl, Spinner, triviaListCategories } from "../../utils/constants";
import BottomScrollListener from "react-bottom-scroll-listener";
import UploadUsersModal from "./Components/UploadUsersModal";
import ResponsePurchaseModal from "./Components/ResponsePurchaseModal";
import TrivvyResponseCounter from "./Components/TrivvyResponseCounter";
import ApplyPurchaseToTrivvy from "./Components/ApplyPurchaseToTrivvyModal";
import DuplicateTriviaPopup from "./Components/DuplicateTriviaPopup";
import TrivvyImmediateRewardToast from "../../components/TrivvyToast/TrivvyImmediateRewardToast";
import CreateTriviaModalMain from "./Components/CreateTrivia/CreateTriviaModalMain";
import TrivvyLinkedRewardsDetailsModal from "./Components/TrivvyLinkedRewardsDetailsModal";
import CheckBox from "rc-checkbox";
import WarningModal from "../../components/Trivvy/WarningModal";
import ManualRemindersModal from "./Components/ManualRemindersModal";

class TriviaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rewardDescModalId: null,
      firstTimePopupText: "",
      uploadFileOpen: false,
      newGeneratedSurvey: [],
      surveyList: [],
      hoveredSurvey: null,
      optionsPopoverOpen: null,
      invidualItemAction: {
        type: null,
        item: null,
      },
      loadingCreateTrivia: false,
      currentPage: 1,
      uploadUsersModal: false,
      purchaseResponsesModal: false,
      responsePurchaseCallbackData: null,
      applyPurchaseModalData: null,
      applyPurchaseOpen: false,
      selectedTrivvys: [],
      selectedTrivvysWarningModal: {
        open: false,
        message: null,
        data:[]
      },
    };
  }
  // 6539c18cc96ae27405744df6
  componentDidMount() {
    const { organizationId } = this.props.user.profile;

    if (this.props.showCreatePopup) {
      this.setState({
        uploadFileOpen: true,
        firstTimePopupText:
          this.props.user && this.props.user.profile
            ? `Welcome, ${this.props.user.profile.firstName} ${this.props.user.profile.lastName}. Let's create your first trivvy. To start select one of the options below.`
            : "",
      });
    } else {
    }

    if (isMobile) {
      this.props.updateNavBar({
        title: "Trivvy",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
    } else {
    }

    let that = this;

    //axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
    //  const payload = data.data;
    //  that.props.orgChangeSuccess(payload);
    //});

    if (!this.props.showTrivvyListOnly) {
      this.retrieveSurveys(1);
    }

    this.props.setCurrentTrivia(null);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.trivvyOpen != nextProps.trivvyOpen && nextProps.trivvyOpen) {
      this.setState({
        uploadFileOpen: true,
      });
    } else {
    }
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      );
    }

    if (this.props.showTrivvyListOnly && this.props.trivvyListPrefetchedArray) {
      if (
        JSON.stringify(this.props.trivvyListPrefetchedArray) !==
          JSON.stringify(nextProps.trivvyListPrefetchedArray) &&
        nextProps.trivvyListPrefetchedArray &&
        nextProps.trivvyListPrefetchedArray.length
      ) {
        this.setState(
          { surveyList: nextProps.trivvyListPrefetchedArray },
          () => {
            this.props.updateSortParams({
              sortOrder: "desc",
              sortBy: "createdDate",
            });
          }
        );
      }
    }

    if (
      JSON.stringify(this.props.importTemplateAddedTrivvys) !==
      JSON.stringify(nextProps.importTemplateAddedTrivvys)
    ) {
      if (nextProps.importTemplateAddedTrivvys.length > 0) {
        this.setState({
          surveyList: [
            ...nextProps.importTemplateAddedTrivvys,
            ...this.state.surveyList,
          ],
        });
        this.props.setImportTemplateAddedTrivvys([]);
      }
    }

    if (
      JSON.stringify(this.props.updateTrivvyLinkedRewards) !==
      JSON.stringify(nextProps.updateTrivvyLinkedRewards)
    ) {
      const updateDoc = nextProps.updateTrivvyLinkedRewards;
      console.log("check 1 ---", updateDoc);
      const trivvysOld = [...this.state.surveyList];

      if (
        updateDoc.rewardId &&
        updateDoc.trivvyIds &&
        updateDoc.trivvyIds.length
      ) {
        for (const id of updateDoc.trivvyIds) {
          const triviaIndex = trivvysOld.findIndex((x) => x._id == id);

          console.log("check 2 ---", triviaIndex);

          if (triviaIndex >= 0) {
            let newDoc = { ...trivvysOld[triviaIndex] };

            newDoc.linkedRewards = [
              ...newDoc.linkedRewards,
              { itemId: updateDoc.rewardId },
            ];
            trivvysOld[triviaIndex] = newDoc;

            console.log("check 3 ---", trivvysOld[triviaIndex]);

            this.setState({
              surveyList: [...trivvysOld],
            });
          }
        }
      }
    }
  }

  handleTrivvyRowCheckboxClick = (value, id) => {
    const trivvys = [...this.state.selectedTrivvys];

    if (trivvys.includes(id)) {
      const newTrivvys = trivvys.filter((x) => x != id);
      this.setState({ selectedTrivvys: newTrivvys });
    } else {
      trivvys.push(id);
      this.setState({ selectedTrivvys: trivvys });
    }
  };

  handleBottomScroll = () => {
    // alert("lll")
    if (!this.props.showTrivvyListOnly) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () => {
        this.retrieveSurveys(this.state.currentPage);
      });
    }
  };

  retrieveSurveys = (page) => {
    const { sortParams } = this.props;
    axios
      .get(url.getIsMessageTrivvys)
      .then(({ data }) => {
        this.setState(
          {
            surveyList: [...this.state.surveyList, ...data.data.surveys],
          },
          () => {
            this.handleSortChange(sortParams.sortBy, sortParams.sortOrder);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleFileUpload = (e) => {
    this.setState({
      uploadedFile: e.target.files[0],
    });
  };

  isValidURL = (url) => {
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/[^\s]*)?$/;
    return urlPattern.test(url);
  };

  getSurveyName = () => {
    const { fileUrl, uploadedFile } = this.state;
    if (uploadedFile) {
      return uploadedFile.name.split(".")[0];
    } else {
      return "Survey - " + moment().format("DD MMM , YYYY");
    }
  };

  handleSortChange = (key, order) => {
    let surveys = [...this.state.surveyList];

    switch (key) {
      case "name":
        surveys = orderBy(surveys, (itm) => itm["name"].toLowerCase(), [order]);
        break;

      case "questionsCount":
        surveys = orderBy(
          surveys,
          (itm) => itm.questions && itm.questions.length,
          [order]
        );
        break;
      case "averageTime":
        surveys = orderBy(surveys, (itm) => itm.averageTime, [order]);
        break;
      case "linkedRewards":
        surveys = orderBy(
          surveys,
          (itm) => itm.linkedRewards && itm.linkedRewards.length,
          [order]
        );
        break;
      case "submissions":
        surveys = orderBy(surveys, (itm) => itm.totalSubmissions, [order]);
        break;
      case "averageScore":
        surveys = orderBy(surveys, (itm) => Math.round(itm.averageScore), [
          order,
        ]);
        break;
      case "createdDate":
        surveys = orderBy(surveys, (itm) => itm.createdOn, [order]);
        break;
      case "endDate":
        surveys = orderBy(surveys, (itm) => itm.trivvyEndDate, [order]);
        break;
      case "source":
        surveys = orderBy(surveys, (itm) => itm.uploadType, [order]);
        break;
      case "status":
        let expired = surveys.filter(
          (itm) =>
            itm.trivvyEndDate &&
            moment(itm.trivvyEndDate).isSameOrBefore(moment(), "day")
        );
        let rest = surveys.filter(
          (itm) => !moment(itm.trivvyEndDate).isSameOrBefore(moment(), "day")
        );
        const rest1 = orderBy(rest, (itm) => itm.isPublished, [order]);

        if (order === "asc") {
          surveys = [...rest1, ...expired];
        } else {
          surveys = [...expired, ...rest1];
        }

        break;

      default:
        surveys = orderBy(surveys, (itm) => itm[key], [order]);
        break;
    }
    this.setState({ surveyList: surveys });
  };

  sortComponent = (key) => {
    const { sortParams } = this.props;
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === "desc") {
        return (
          <BiDownArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "asc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      } else {
        return (
          <BiUpArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "desc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      }
    } else {
      return (
        <BiUpArrowAlt
          size={"13px"}
          onClick={() => this.changeSortField(key, "desc")}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      );
    }
  };

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    });
  };

  redirectToSurveyPage = (survey) => {
    // this.props.setCurrentTrivia(survey);
    const { organizationId } = this.props.user.profile;
    this.props.history.push(
      `/home/trivia/${organizationId._id}/edit/${survey._id}/results`
    );
  };

  openApplyPurchaseModal = (data) => {
    this.setState({ applyPurchaseOpen: true, applyPurchaseModalData: data });
  };
  closeApplyPurchaseModal = (data) => {
    this.setState({ applyPurchaseOpen: false, applyPurchaseModalData: null });
  };

  handleDropdownAction = (actionType, item) => {
    this.setState({ optionsPopoverOpen: null });
    if (actionType === "REMIND") {
      this.setState({
        invidualItemAction: {
          type: "REMIND",
          item: item,
        },
      });
    }
    if (actionType === "OPEN") {
      this.redirectToSurveyPage(item);
    }
    if (actionType === "RENAME") {
      this.setState({
        invidualItemAction: {
          type: "RENAME",
          item: item,
        },
      });
    }
    if (actionType === "PURCHASE") {
      this.openApplyPurchaseModal(item);
    }

    if (actionType === "DUPLICATE") {
      this.setState({
        invidualItemAction: {
          type: "DUPLICATE",
          item: item,
        },
      });
    }

    if (actionType === "COPY") {
      navigator.clipboard.writeText(
        `${baseUrl()}home/trivia/${item.organizationId}/quiz/${item._id}/start`
      );
    }
    if (actionType === "DELETE") {
      this.setState({
        invidualItemAction: {
          type: "DELETE",
          item: item,
        },
      });
    }

    if (actionType === "PUBLISH") {
      axios
        .put(url.updateTrivvyPublish(item._id), {
          updateData: { isPublished: !item.isPublished },
        })
        .then((data) => {
          const updated = {
            ...item,
            isPublished: !item.isPublished,
          };

          this.onUpdateItem(updated);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  closeInvidualItemAction = () => {
    this.setState({
      invidualItemAction: {
        type: null,
        item: null,
      },
    });
  };

  renderRowOptions = (item) => {
    const { optionsPopoverOpen } = this.state;
    if (item && item._id) {
      return (
        <div className="cursor-pointer">
          <span
            id={`surveyListRow_${item._id}`}
            onClick={(e) => { 
              e.stopPropagation();
              this.setState({ optionsPopoverOpen: item._id })}}
            className="cursor-pointer"
          >
            <BsThreeDots />
          </span>

          <Popover
            isOpen={optionsPopoverOpen == item._id}
            target={`surveyListRow_${item._id}`}
            toggle={() => this.setState({ optionsPopoverOpen: null })}
            placement="bottom"
            hideArrow
            className="surveyListRow_Popover"
          >
            <PopoverBody className="">
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction("OPEN", item);
                }}
              >
                View
              </div>

              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction("RENAME", item);
                }}
              >
                Rename
              </div>

              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction("DELETE", item);
                }}
              >
                Delete
              </div>

              {item.waitingCount > 0 && (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.handleDropdownAction("PURCHASE", item);
                  }}
                >
                  Manage Purchase
                </div>
              )}
            </PopoverBody>
          </Popover>
        </div>
      );
    } else {
      return null;
    }
  };

  onDeleteItem = (id) => {
    const { surveyList } = this.state;
    const docs = [...surveyList];

    const newDocs = docs.filter((x) => x._id != id);

    this.setState({ surveyList: newDocs });

    this.closeInvidualItemAction();

    if (this.props.onDeleteFromLibList) {
      this.props.onDeleteFromLibList();
    }
  };

  onUpdateItem = (updated) => {
    const { surveyList } = this.state;
    let docs = [...surveyList];

    const itemIndex = docs.findIndex((x) => x._id == updated._id);
    if (itemIndex >= 0) {
      docs[itemIndex] = updated;

      this.setState({ surveyList: docs });
    }

    this.closeInvidualItemAction();
  };

  addTrivvySuccessFromTemplates = (newData) => {
    this.props.setCreateModalState(false);
    this.setState({
      surveyList: [...newData, ...this.state.surveyList],
      templateModalOpen: false,
    });
  };

  handleAfterAddTrivia = (newSurvey) => {
    this.props.setCreateModalState(false);
    if (newSurvey.triviaType == 2 || newSurvey.duplicatedFromTrivvy) {
      const surveys = [...this.state.surveyList];
      surveys.unshift(newSurvey);
      this.setState({
        surveyList: [...surveys],
        uploadFileOpen: false,
      });
      if (this.props.setTrivvyOpen) {
        this.props.setTrivvyOpen(false);
      }

      if (newSurvey) {
        if(newSurvey.isMessaging){
          this.props.history.push(`/home/trivia/${newSurvey.organizationId}/edit/${newSurvey._id}/results`)
        }else{
          this.props.history.push(`/home/trivia/${newSurvey.organizationId}/edit/${newSurvey._id}/edit`)
        }
       
      }
    } else {
      
    }
  };

  onTrivvyMultiGenerate = (payload, apiData) => {
    const surveys = [...payload.partsArray, ...this.state.surveyList];
    this.setState(
      {
        surveyList: [...surveys],
        uploadFileOpen: false,
        loadingCreateTrivia: true,
      },
      () => {
        if (this.props.setTrivvyOpen) {
          this.props.setTrivvyOpen(false);
        }
        this.setState({
          newGeneratedSurvey: payload.partsArray.map((x) => x.name),
        });
      }
    );

    axios
      .post(url.createOrScheduleMultipleTrivvys, apiData)
      .then(({ data }) => {
        const surveys = [...this.state.surveyList].filter((x) => x._id);

        this.setState({
          surveyList: [...data.data, ...surveys],
          newGeneratedSurvey: [],
          loadingCreateTrivia: false,
        });

        for (const item of data.data) {
          if (item.isPublished) {
            axios.put(url.shareTrivia(item._id), {
              sharedWithUsers: item.sharedWithUsers,
              privacy: item.privacy,
              shareTrivvyViaSMS: item.shareTrivvyViaSMS,
              shareTrivvyViaEmail: item.shareTrivvyViaEmail,
            });
          }
        }

        toastContainer(
          <TrivvyImmediateRewardToast
            history={this.props.history}
            trivvyIds={data.data.map((x) => x._id)}
            noPlanCustomMessage={"Questions generated successfully"}
          />,
          "success"
        );
      })
      .catch((error) => {
        surveys.shift();
        this.setState({
          newGeneratedSurvey: [],
          loadingCreateTrivia: false,
          surveyList: [...surveys],
        });
        let errorMsg = WEB_GENERATE_ERROR_MESSAGE;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message == "ad_blocker"
        ) {
          errorMsg =
            "Sorry, we could not process this because there is a blocker on this website. Please save and upload as a PDF or copy and paste the text.";
        }
        toastContainer(errorMsg, "error");

        console.log(error);
      });
  };

  getDataForExportResult = () => {
    const { surveyList } = this.state;

    if (surveyList && surveyList.length) {
      const newList = surveyList.map((item) => ({
        name: item.name || "NA",
        totalQuestions: item.questions ? item.questions.length : 0,
        averageScore: `${Math.round(item.averageScore || 0)}%`,
        averageTime: `${Math.round(item.averageTime || 0)} sec`,
        source:
          item.uploadType == 0
            ? "Webpage"
            : item.uploadType == 1
            ? "Document"
            : "Custom Text",
        publishStatus: item.isPublished
          ? !moment(item.trivvyEndDate).isSameOrBefore(moment(), "day") ||
            item.trivvyEndDate == null ||
            !item.trivvyEndDate
            ? "Published"
            : "Ended"
          : "NotPublished",
        createdOn: item.createdOn
          ? moment(item.createdOn).format("h:mma on MMM D, YYYY")
          : "NA",
        totalSubmissions: item.totalSubmissions || 0,
      }));

      return newList;
    } else {
      return [];
    }
  };

  addTrivvySuccessFromTemplates = (data) => {
    if (this.props.setImportTemplateAddedTrivvys) {
      this.props.setImportTemplateAddedTrivvys(data);
      this.setState({
        uploadFileOpen: false,
      });
      if (this.props.setTrivvyOpen) {
        this.props.setTrivvyOpen(false);
      }
    }
  };

  goToRewards = () => {
    this.setState({
      uploadFileOpen: false,
    });
    if (this.props.setTrivvyOpen) {
      this.props.setTrivvyOpen(false);
    }
    this.props.handleGlobalRewardModal({
      open: true,
      trivvys: [],
    });
  };

  handleMultiplePublishUnPublish = (flag) => {
    axios
      .post(url.updateTrivvyPublishMultiple, {
        updateData: { isPublished: flag },
        trivvysToUpdate: this.state.selectedTrivvys,
      })
      .then((data) => {
        const updatedTrivias = data.data.data.trivias;

        this.setState({
          selectedTrivvys: [],
        });

        for (const itm of updatedTrivias) {
          this.onUpdateItem(itm);
        }

        toastContainer("Updated succesfully", "success");
        this.setState({selectedTrivvys:[]})
      })
      .catch((err) => {
        console.log(err);
        toastContainer("Error occured while updating", "error");
      });
  };

  handleMultipleDelete = () => {
    axios
      .post(url.deleteMultipleTrivias, {
        trivvysToDelete: this.state.selectedTrivvys,
      })
      .then((data) => {
        const deletedIds = this.state.selectedTrivvys;

        const filtered = [...this.state.surveyList].filter(
          (x) => !deletedIds.includes(x._id)
        );

        this.setState({
          surveyList: [...filtered],
        });

        toastContainer("Deleted succesfully", "success");
        this.setState({selectedTrivvys:[]})
      })
      .catch((err) => {
        console.log(err);
        toastContainer("Error occured while deleting trivvys", "error");
      });
  };

  render() {
    const orgObject = this.props.user.profile.organizationId;
    const trivvy_plan_type = orgObject && orgObject.trivvyPlanType;
    const {
      uploadFileOpen,
      uploadedFile,
      trivvyCatModal,
      fileUrl,
      surveyList,
      hoveredSurvey,
      invidualItemAction,
      newGeneratedSurvey,
      loadingCreateTrivia,
      uploadUsersModal,
      purchaseResponsesModal,
      applyPurchaseModalData,
      applyPurchaseOpen,
      preSelectedTriviaIds,
      rewardDescModalId,
      selectedTrivvys,
      selectedTrivvysWarningModal,
    } = this.state;
    const tableCols = {
      name: 3,
      createdOn: 2,
      messageBody: 2,

      responses: 2,

      action: 1,
      //rating: 1,
      scheduledOn: 2,
    };

    const tableColsMobile = {
      createdOn: 3,
      messageBody: 4,

      responses: 2,

      action: 1,
      //rating: 1,
      scheduledOn: 2,
    };

    const { showTrivvyListOnly } = this.props;

    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == "Admin";

    const isTrivvyOfNonMcq = (trivvy) => {
      return (
        trivvy.questions &&
        trivvy.questions.filter((x) => x.question_type == "MCQ").length == 0
      );
    };

    return (
      <div id="triviaListPage">
        {rewardDescModalId && rewardDescModalId.length > 0 ? (
          <TrivvyLinkedRewardsDetailsModal
            open={rewardDescModalId.length > 0}
            onClose={() =>
              this.setState({
                rewardDescModalId: null,
              })
            }
            trivvyId={rewardDescModalId}
          />
        ) : (
          ""
        )}
        {applyPurchaseOpen && applyPurchaseModalData ? (
          <ApplyPurchaseToTrivvy
            open={applyPurchaseOpen}
            onClose={this.closeApplyPurchaseModal}
            handleUpdateRow={this.onUpdateItem}
            trivia={applyPurchaseModalData}
          />
        ) : (
          ""
        )}
        {uploadFileOpen && (
          <CreateTriviaModalMain
            open={uploadFileOpen}
            onClose={() => {
              this.props.setCreateModalState(false);
              this.setState({ uploadFileOpen: false });
              if (this.props.setTrivvyOpen) {
                this.props.setTrivvyOpen(false);
              }
            }}
            setCreateModalState={this.props.setCreateModalState}
            onAddSuccess={this.handleAfterAddTrivia}
            user={this.props.user}
            addTrivvySuccessFromTemplates={this.addTrivvySuccessFromTemplates}
            firstTimePopupText={this.state.firstTimePopupText}
            goToRewards={this.goToRewards}
            canCreateRewards={surveyList && surveyList.length > 0}
            onTrivvyMultiGenerate={this.onTrivvyMultiGenerate}
            onlyShowMessageWindow={true}
          />
        )}

        {invidualItemAction &&
        invidualItemAction.type === "RENAME" &&
        invidualItemAction.item ? (
          <RenamePopup
            onClose={() => {
              this.closeInvidualItemAction();
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === "RENAME"}
            onUpdateItem={this.onUpdateItem}
          />
        ) : (
          ""
        )}

        {invidualItemAction &&
        invidualItemAction.type === "DELETE" &&
        invidualItemAction.item ? (
          <DeleteTriviaPopup
            onClose={() => {
              this.closeInvidualItemAction();
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === "DELETE"}
            onDeleteItem={this.onDeleteItem}
            isMessaging
            type={this.state.invidualItemAction.type}
          />
        ) : (
          ""
        )}

        {!showTrivvyListOnly && (
          <div>
            {!isMobile && (
              <Button
                className="trivia-action-button-main mr-4 trivv-create-btn mt-2 create-trivvy-btn-itm"
                onClick={() => {
                  this.setState({
                    uploadFileOpen: true,
                  });
                }}
                // color="success"
                size="sm"
                disabled={loadingCreateTrivia}
              >
                + Create Message
              </Button>
            )}

            {!isMobile &&
              isAdmin &&
              this.props.user.profile.organizationId.trivvyPlanType !=
                "001" && (
                <Button
                  className="trivia-action-button-main add-reward-btn mr-4 mt-2"
                  onClick={() => {
                    this.props.handleGlobalRewardModal({
                      open: true,
                      trivvys: [],
                    });
                  }}
                >
                  Set reward <GiOpenTreasureChest />
                </Button>
              )}

            {isMobile && isAdmin && (
              <div className="mb-4 ml-3">
                <UncontrolledDropdown direction="down">
                  <DropdownToggle className="trivia-action-button-main">
                    <GiBigGear /> Trivvy options
                  </DropdownToggle>
                  <DropdownMenu className="pt-2 pr-2 mt-2">
                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          uploadFileOpen: true,
                        });
                      }}
                      className="my-1"
                    >
                      Create Trivvy +
                    </DropdownItem>

                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          trivvyCatModal: true,
                        });
                      }}
                      className="my-1"
                    >
                      Set Reward <GiOpenTreasureChest />
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            )}

            {uploadUsersModal && (
              <UploadUsersModal
                open={uploadUsersModal}
                onClose={() => {
                  this.setState({
                    uploadUsersModal: false,
                  });
                }}
              />
            )}
          </div>
        )}

        {selectedTrivvys && selectedTrivvys.length ? (
          <div style={{}} className="mt-4">
            
            <b
              className="mx-2 text-danger cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message: "Are you sure you want to delete selected messages",
                    type: "DELETE",
                    data:this.state.selectedTrivvys.map(x =>{

                      const itm = this.state.surveyList.find(k => k._id == x)

                      return itm
                    })
                  },
                });
              }}
            >
              Delete
            </b>

            <span>Selected messages ({selectedTrivvys.length})</span>
          </div>
        ) : (
          ""
        )}

        {selectedTrivvysWarningModal && selectedTrivvysWarningModal.open ? (
          <WarningModal
            open={selectedTrivvysWarningModal.open}
            message={selectedTrivvysWarningModal.message}
            type={selectedTrivvysWarningModal.type}
            onCancel={() => {
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: "",
                  type: "",
                  data:[]
                },
              });
            }}
            selectedRows={selectedTrivvysWarningModal.data}
            onOk={() => {
              if (selectedTrivvysWarningModal.type === "PUBLISH") {
                this.handleMultiplePublishUnPublish(true);
              } else if (selectedTrivvysWarningModal.type === "UNPUBLISH") {
                this.handleMultiplePublishUnPublish(false);
              } else if (selectedTrivvysWarningModal.type === "DELETE") {
                this.handleMultipleDelete();
              }
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: "",
                  type: "",
                  data:[]
                },
              });
            }}
            onClose={() => {
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: "",
                  type: "",
                  data:[]
                },
              });
            }}
            isMessaging
          />
        ) : (
          ""
        )}

        {surveyList.length == -1 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={"No messages found"}
              subtitle={
                "You havent created any trivias yet. Please create from button above."
              }
            />
          </div>
        ) : (
          <div>
            {!isMobile ? (
              <div
              // style={{
              //   minWidth: "100%",
              //   maxWidth: "100%",
              //   overflowX: "auto",
              // }}
              // className="hide-scroll"
              >
                <div
                  className="trivia_survey_list_table"
                  // style={{
                  //   width: "1500px",
                  // }}
                >
                  <div className="my-0">
                    <LayoutRowShadow className="row-shadow-header-no-shadow px-15em mx-0">
                      <LayoutHeadingShadowLeft
                        className={"text-left"}
                        colWidth={tableCols.name}
                      >
                        <span>Name {this.sortComponent("name")} </span>
                      </LayoutHeadingShadowLeft>

                      <If condition={true}>
                        <LayoutHeadingShadow
                          className={"justify-content-center "}
                          colWidth={tableCols.createdOn}
                        >
                          Created {this.sortComponent("createdDate")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"justify-content-center "}
                          colWidth={tableCols.responses}
                        >
                          <div
                            style={{ display: "block" }}
                            // style={{ flexDirection: "column" }}
                          >
                            Responses |{" "}
                            <span className="waiting_text">Waiting</span>
                          </div>{" "}
                          {this.sortComponent("submissions")}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.rating}
                        >
                          Scheduled {this.sortComponent("scheduledDate")}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.rating}
                        >
                          Message {this.sortComponent("scheduledDate")}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.action}
                        ></LayoutHeadingShadow>
                      </If>
                    </LayoutRowShadow>
                    <BottomScrollListener
                      offset={100}
                      onBottom={this.handleBottomScroll}
                    >
                      {(scrollRef) => (
                        <div
                          className={`trivia_survey_list_table_contents_scroll ${
                            surveyList.length == 0 ? "trivvy-no-results" : ""
                          }`}
                          ref={scrollRef}
                        >
                          {!isMobile && surveyList.length > 0 ? (
                            surveyList.map((item, idx) => {
                              const loadingGeneratingQuestions =
                                newGeneratedSurvey &&
                                Array.isArray(newGeneratedSurvey) &&
                                newGeneratedSurvey.includes(item.name) &&
                                !item._id;

                              let itm_color =
                                idx % 2 == 0 ? "#ff6233" : "#c6ffe7";

                              if (loadingGeneratingQuestions) {
                                return (
                                  <LayoutRowShadow>
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer"
                                    >
                                      <div
                                        className="d-flex"
                                        data-tip={item.name}
                                      >
                                        <span
                                          className="trivia-list-item-color-chip"
                                          style={{ backgroundColor: itm_color }}
                                        />
                                        <div style={{ flex: 1 }}>
                                          <div
                                            className="survey-item-title survey-item-title-itm"
                                            onClick={() =>
                                              this.redirectToSurveyPage(item)
                                            }
                                          >
                                            <span className="survey-item-title">
                                              {item.name ? item.name : item.messagingSubject ? (item.messagingSubject.slice(0,5)+"..."):"" }
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <ReactTooltip />
                                    </LayoutData>
                                    <LayoutData>
                                      <div className="text-center">
                                        {" "}
                                        <img
                                          src={Spinner}
                                          height="25px"
                                          width={"25px"}
                                        />{" "}
                                      </div>
                                    </LayoutData>
                                  </LayoutRowShadow>
                                );
                              } else {
                                return (
                                  <LayoutRowShadow
                                    key={idx}
                                    onMouseEnter={() =>
                                      this.setState({ hoveredSurvey: item._id })
                                    }
                                    onMouseLeave={() =>
                                      this.setState({ hoveredSurvey: null })
                                    }
                                    onClick={() =>
                                      this.redirectToSurveyPage(item)
                                    }
                                  >
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer"
                                    >
                                      <div
                                        data-tip={item.name}
                                        className="d-flex"
                                      >
                                        <CheckBox
                                          checked={selectedTrivvys.includes(
                                            item._id
                                          )}
                                          className="mr-2"
                                          onChange={(e) => {
                                            this.handleTrivvyRowCheckboxClick(
                                              e.target.checked,
                                              item._id
                                            );
                                          }}
                                        />

                                        <span className="survey-item-title">
                                        {item.name ? item.name : item.messagingSubject ? item.messagingSubject.slice(0,5):"" }
                                        </span>
                                      </div>
                                      <ReactTooltip />

                                      {hoveredSurvey == item._id ? (
                                        <Button
                                          className="hover-survey-button-position trivia-action-button-secondary"
                                          onClick={() =>
                                            this.redirectToSurveyPage(item)
                                          }
                                        >
                                          View
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.createdOn}
                                    >
                                      {" "}
                                      <div className="survey-createddate-text">
                                        <div>
                                          {moment(item.createdOn).format(
                                            "h:mma on "
                                          )}
                                        </div>
                                        <div>
                                          {moment(item.createdOn).format(
                                            "MMM D, YYYY"
                                          )}
                                        </div>
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.responses}
                                    >
                                      <div style={{ flexDirection: "row" }}>
                                        <span className="mr-1">
                                          {item.totalSubmissions || 0}
                                        </span>{" "}
                                        |
                                        <span className="ml-1 waiting_text">
                                          {item.waitingCount}
                                        </span>
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.scheduledOn}
                                    >
                                      {" "}
                                      <div className="survey-createddate-text">
                                        {item.scheduledDate ? (
                                          <span>
                                            <div>
                                              {moment(
                                                item.scheduledDate
                                              ).format(
                                                // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                                "h:mma on"
                                              )}
                                            </div>
                                            <div>
                                              {moment(
                                                item.scheduledDate
                                              ).format(
                                                // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                                "MMM D, YYYY"
                                              )}
                                            </div>
                                          </span>
                                        ) : (
                                          <div className="text-center">
                                            <LuCalendarCheck
                                              size={23}
                                              color="gray"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                    
                                      colWidth={tableCols.messageBody}
                                    >
                                      {item.messagingSubject && item.messagingSubject.slice(0,6)}...
                                    </LayoutData>
                                 

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.action}
                                    >
                                      {hoveredSurvey == item._id ||
                                      hoveredSurvey != item._id
                                        ? this.renderRowOptions(item)
                                        : null}
                                    </LayoutData>
                                  </LayoutRowShadow>
                                );
                              }
                            })
                          ) : (
                            <span>No messages created</span>
                          )}
                        </div>
                      )}
                    </BottomScrollListener>
                  </div>
                </div>
              </div>
            ) : (
              <div className="trivia_table_mobile mt-4">
                <BottomScrollListener onBottom={this.handleBottomScroll}>
                  {(scrollRef) => (
                    <div
                      className="trivia_survey_list_table_contents_scroll"
                      ref={scrollRef}
                    >
                      <Row>
                        <Col xs={5} className="px-0">
                          <LayoutHeadingShadow
                            className={"justify-content-center"}
                            colWidth={12}
                          >
                            Name {this.sortComponent("name")}{" "}
                          </LayoutHeadingShadow>

                          {surveyList.length == 0 ? (
                            <Row
                              className={
                                "planning-row-mobile-height layout-row-shadow mx-0"
                              }
                            >
                              <LayoutData colWidth={12}>
                                No messages created
                              </LayoutData>
                            </Row>
                          ) : (
                            ""
                          )}

                          {surveyList.map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={
                                  "planning-row-mobile-height mx-0 px-0"
                                }
                              >
                                <LayoutDataLines colWidth={12} noFlex>
                                  <div
                                    onClick={() =>
                                      this.redirectToSurveyPage(item)
                                    }
                                    className="cursor-pointer"
                                  >
                                    <div
                                      className="survey-item-title-itm"
                                      data-tip={item.name}
                                    >
                                      <span className="survey-item-title">
                                      {item.name ? item.name : item.messagingSubject ? item.messagingSubject.slice(0,5):"" }
                                      </span>
                                    </div>
                                    <ReactTooltip />
                                  </div>
                                  <ReactTooltip />
                                </LayoutDataLines>
                              </LayoutRowLines>
                            );
                          })}
                        </Col>

                        <Col
                          xs={7}
                          className="scrollable-action-table-row px-0"
                        >
                          <LayoutRowLines className="row-scroll-width-s">
                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.createdOn}
                            >
                              Created {this.sortComponent("createdDate")}
                            </LayoutHeadingShadow>

                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.responses}
                            >
                              <div
                                style={{ display: "block" }}
                                // style={{ flexDirection: "column" }}
                              >
                                Responses |{" "}
                                <span className="waiting_text">Waiting</span>
                              </div>{" "}
                              {this.sortComponent("submissions")}
                            </LayoutHeadingShadow>

                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.avgScore}
                            >
                              Scheduled {this.sortComponent("scheduledDate")}
                            </LayoutHeadingShadow>
                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.avgScore}
                            >
                              Message {this.sortComponent("scheduledDate")}
                            </LayoutHeadingShadow>

                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.action}
                            ></LayoutHeadingShadow>
                          </LayoutRowLines>

                          {surveyList.map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={`pl-tasks-row ${
                                  isMobile ? "row-scroll-width-s" : ""
                                }`}
                              >
                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.createdOn}
                                >
                                  {" "}
                                  <div className="survey-createddate-text text-info">
                                    {moment(item.createdOn).format(
                                      "h:mma on MMM D, YYYY"
                                    )}
                                  </div>
                                </LayoutDataLines>

                                <LayoutDataLines
                                  className="text-center py-1 font-13px"
                                  colWidth={tableColsMobile.responses}
                                >
                                  <span className="mr-1">
                                    {item.totalSubmissions || 0}
                                  </span>
                                  |
                                  <span className="ml-1 waiting_text">
                                    {item.waitingCount}
                                  </span>
                                </LayoutDataLines>

                                <LayoutDataLines
                                  colWidth={tableColsMobile.scheduledOn}
                                  className="text-center text-success font-13px"
                                >
                                  <div className="survey-createddate-text">
                                    {item.scheduledDate ? (
                                      <span>
                                        <div>
                                          {moment(item.scheduledDate).format(
                                            // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                            "h:mma on"
                                          )}
                                        </div>
                                        <div>
                                          {moment(item.scheduledDate).format(
                                            // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                            "MMM D, YYYY"
                                          )}
                                        </div>
                                        {/* <div>
                                          {moment(item.scheduledDate).format(
                                            // "MMM DD, YYYY 𝖺𝗍 hh:mm a"
                                            "h:mma on MMM D, YYYY"
                                          )}
                                        </div> */}
                                      </span>
                                    ) : (
                                      <div className="text-center">
                                        <LuCalendarCheck
                                          size={23}
                                          color="gray"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </LayoutDataLines>

                                <LayoutData
                                     
                                      colWidth={tableColsMobile.messageBody}
                                    >
                                      {item.messagingSubject && item.messagingSubject.slice(0,6)}...
                                    </LayoutData>
                                <LayoutDataLines
                                  colWidth={tableColsMobile.action}
                                  className="text-center"
                                >
                                  {this.renderRowOptions(item)}
                                </LayoutDataLines>
                              </LayoutRowLines>
                            );
                          })}
                        </Col>
                      </Row>
                    </div>
                  )}
                </BottomScrollListener>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaMessages
        ? state.sortFilterParams.triviaMessages.sort &&
          state.sortFilterParams.triviaMessages.sort.hasOwnProperty("sortBy")
          ? state.sortFilterParams.triviaMessages.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },

    importTemplateAddedTrivvys: state.trivia.importTemplateAddedTrivvys,
    showCreatePopup: state.trivia.showCreatePopup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) => dispatch(actionCreators.updateTriviaSort(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),

    handleGlobalRewardModal: (data) =>
      dispatch(actionCreators.handleGlobalRewardModal(data)),
    setCreateModalState: (data) =>
      dispatch(actionCreators.setCreateModalState(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaList, axios));
